import React from "react";
//import ScrollButton from "../containers/ScrollButton/ScrollButton";
import "./Content.scss";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Content from './content/Content'
import ArrowBackStandar from '../ArrowBack/ArrowBackStandar';
import { width } from "styled-system";
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import useScript from '../../utils/customHooks/useScript';
import AntSwitch from '../../utils/props/AntSwitch'
import MembershipCard from '../MembershipsCards/MembershipCard'
import * as ROUTES from '../../routes';
import MembershipModal from "../Modal/MembershipModal";
import ScrollToTop from '../../components/ScrollToTop';
import { openModalPayments } from "../../store/actions/ModalsActions";
import { connect } from 'react-redux';



import BtnSwitch from '../BtnMembership/BtnSwitch';

const membershipFree = [ {text: <p className='feactures_text'>Perfil profesional público</p> }, 
{text: <p className='feactures_text'>Análisis de resultados en tu cuenta</p>},
{  text: <p className='feactures_text'>Acceso a la comunidad de abogados</p>},
/* {text: <p className='feactures_text'>Enlace del perfil a redes sociales y WhatsApp</p>}, */
{text: <p className='feactures_text'>Soporte vía telefónica, WhatsApp o email por parte de nuestros asesores</p>} ]


const membershipPremiuns = [     {text: <p className='feactures_text'><strong>Incluye todo los beneficios de la membresía Free</strong></p>},
{text: <img className='top-16-0' src='/img/icons/plus-m.svg' alt="icon" />},
{text: <p className='feactures_text'><strong>Perfil profesional</strong> completo y público</p> }, 

{  text: <p className='feactures_text'><strong>Buen posicionamiento</strong> en listados de búsqueda, por detrás de Premium Plus</p>},
/* {text: <p className='feactures_text'><strong>Chat directo</strong> con los clientes</p>},
{text: <p className='feactures_text'><strong>Cotizaciones en línea</strong> para todos tus clientes</p>}, */

{text: <p className='feactures_text'>Agrega hasta  <strong>5 colaboradores</strong> de tu despacho</p>},

{text: <p className='feactures_text'>Agrega hasta <strong>2 sedes</strong></p>},
{text: <p className='feactures_text'><strong>Recibe valoraciones de clientes</strong> por los servicios del despacho</p>},
{text: <p className='feactures_text'><strong>Sube imágenes y links de videos</strong> relacionados con tus servicios </p>},
{text: <p className='feactures_text'><strong>Notificaciones</strong> en tiempo real</p>} ]


const membershipPlus = [     {text: <p className='feactures_text'><strong>Incluye todo los beneficios de la membresía Premium</strong></p>},
{text: <img className='top-16-0' src='/img/icons/plus-m.svg' alt="icon" />},
{text: <p className='feactures_text'><strong>El mejor posicionamiento en listados de búsqueda</strong></p> }, 

{  text: <p className='feactures_text'><strong>Distintivo Premium Plus</strong> dentro de los listados</p>},

{  text: <p className='feactures_text'><strong>Perfil abogado Premium</strong> para el titular del despacho</p>},
{text: <p className='feactures_text'><strong>Soporte vía telefónica, WhatsApp o email</strong> por parte de nuestros asesores</p>},
{  text: <p className='feactures_text'>Agrega hasta <strong>10 colaboradores</strong> de tu despacho</p>},
{  text: <p className='feactures_text'>Agrega hasta <strong>5 sedes</strong></p>}]





function Memberships(props) {
  const breakpoint = useMediaQuery('(min-width:768px)');
  const [state, setState] = React.useState({
    yearlyLawyer: true,
  });

  const { platinum, openModalPayments } = props;
  let monthly =  state.yearlyLawyer ? "twelveMonths" : "sixMonths" //sixMonths annual

  const handleOpenModal = (membership,) => {

    if(!props.role){
      openModalPayments(true, 'noSession');
    }else if(props.role === 'lawyer'){
      openModalPayments(true, 'lawFirm', membership, monthly);
    }else if(props.role === 'lawFirm'){
      openModalPayments(true, 'lawFirm', membership, monthly);
    }

  }

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <>
    <ScrollToTop />
    <MembershipModal />
    <div className="mships">
      <div className="mships-mainContent">
        <div className="mships-content_arrow">
            <ArrowBackStandar text="Regresar"/>
        </div>
        <div className='mships-content_titles'>
          <p className="mships-mainTitle">Membresías despachos</p>
          <p className="mships-description">
            Sé parte de la plataforma con los mejores abogados en México 
          </p> 

          <div className='mships-switch'>
          <p className="mships-textMonthly">Semestral</p>
              <AntSwitch checked={state.yearlyLawyer} onChange={handleChange} name="yearlyLawyer" />
          <p className="mships-oneTimePayment">Anual - 15%</p>
                
          </div>
          <div className='mships-container_cards'>

         
            <MembershipCard type='free' textBtn={'Regístrate'}
              title={'Free'} cost={'0'} status={'disable_btn'}
              handleClick={() => {}}
              infoMembership={membershipFree}  
              benefits={'Para obtener mayores beneficios adquiere PREMIUM'}/>
            <MembershipCard type='premiunFirm'  
              textBtn={'Obtener'} status={'avtive-btn'}
              handleClick={()=>{handleOpenModal('Premium')}}
              title={'Premium'} cost={state.yearlyLawyer ? '1,104' : '1,299'} 
              infoMembership={membershipPremiuns} period={state.yearlyLawyer}
              benefits={state.yearlyLawyer ? 'Más IVA, facturado mensualmente' : 'Más IVA, facturado mensualmente'}
            />
            <MembershipCard type='plusFirm' 
              textBtn={'Obtener'} status={'avtive-btn'}
              title={'Premium Plus'} cost={state.yearlyLawyer ? '1,699' : '1,999'} 
              handleClick={()=>{handleOpenModal('Premium Plus')}}
              infoMembership={membershipPlus} period={state.yearlyLawyer}
              benefits={state.yearlyLawyer ? 'Más IVA, facturado mensualmente' : 'Más IVA, facturado mensualmente'}
            />
          </div>
          <p className='mships-subTitle'>¿Te interesa participar solo?</p>
          <BtnSwitch textBtn={'Ver planes para abogado'} linkTo={ROUTES.MEMBERSHIPS_LAWYERS} />

        </div>

      </div>
    </div>
    </>
  );
}


const mapDispatchToProps = dispatch => ({
  openModalPayments: (open, membershipRole, typeMembership, typePayment, ) => dispatch(openModalPayments(open, membershipRole, typeMembership, typePayment, ))
})
const mapStateToProps = (state) => ({
  role: state.authClient.role,
  modalPayments: state.ModalReducer.openModalPayments
});


export default connect(mapStateToProps, mapDispatchToProps)(Memberships);


